import Image, { ImageProps } from "@Components/weather-report/figure/Image";
import classNames from "classnames";

const Figure = ({
  source,
  legend,
  format,
  showCaption = !!legend && format === "default",
  testId = "",
  ...rest
}: ImageProps & { showCaption?: boolean }) => (
  <figure
    className={classNames("m:m-0 m:block", {
      "m:mt-6 m:self-center m:md:float-right": format === "compact",
    })}>
    <Image format={format} testId={testId} {...rest} />
    {showCaption && (
      <div className="m:bg-background-secondary m:tracking-tracking-0.4 m:flex m:flex-col m:bg-warmgrey-25 m:px-6 m:py-3 m:dark:bg-warmgrey-1000">
        <span className="m:sr-only">Legende:</span>
        <span className="m:text-[16px] m:leading-5 m:font-medium m:tracking-0.4">
          {legend}
        </span>
        {source && (
          <span className="m:mt-2 m:text-[12px] m:leading-3 m:font-normal m:text-warmgrey-700">
            {source.toUpperCase()}
          </span>
        )}
      </div>
    )}
  </figure>
);

export default Figure;
